import { TextField, Paper, Table, TableHead, TableRow, TableCell, TableBody, TablePagination, Box, Button, Switch, IconButton } from "@mui/material";
import Wrapper from "../components/Wrapper";
import { useEffect, useState } from "react";
import moment from "moment";
import { enqueueSnackbar } from "notistack";
import { Link } from "react-router-dom";
import { Edit, Image } from "@mui/icons-material";
import ThumbnailDialog from "../components/ThumbnailDialog";
import { listModalities, updateModality } from "../services/modality";

const Modalities = () => {

  const [modalities, set_modalities] = useState([]);
  const [page, set_page] = useState(0);
  const [count, set_count] = useState(0);
  const [search, set_search] = useState('');
  const [show_thumbnail_dialog, set_show_thumbnail_dialog] = useState(false);
  const [selected_id, set_selected_id] = useState('');
  const [thumbnail_file_name, set_thumbnail_file_name] = useState(null);

  const getData = async () => {
    const { data } = await listModalities({
      page: page,
      limit: 10,
      search: search
    })

    if (data) {
      set_modalities(data.data);
      set_count(data.total_records);
    }
  }

  const handleChangePage = (event, page_no) => {
    set_page(page_no)
  }

  useEffect(() => {
    getData();

    // eslint-disable-next-line
  }, [page, search])

  const handleChangeActiveStatus = async (status, id) => {
    const { data, error } = await updateModality({
      data: {
        active: status
      },
      id: id
    });

    if (data) {
      getData();
      enqueueSnackbar('Status updated successfully', {
        variant: 'success'
      })
    }
    if (error) {
      enqueueSnackbar('Error while updating status', {
        variant: 'error'
      })
    }
  }

  const showThumbnailDialog = (modality) => {
    set_selected_id(modality._id);
    set_show_thumbnail_dialog(true);
    set_thumbnail_file_name(modality.thumbnail_filename)
  }

  const closeDialog = () => {
    set_selected_id('');
    set_thumbnail_file_name(null);
    set_show_thumbnail_dialog(false);
  }

  return (
    <Wrapper>
      <Box
        component='div'
        display='flex'
        justifyContent='space-between'
        alignItems='center'
      >
        <TextField
          label='Search'
          sx={{
            width: '450px'
          }}
          value={search}
          onChange={(e) => set_search(e.target.value)}
        />

        <Box component='div'>
          <Link
            to='/add-modality'
            className="d-inline-block"
          >
            <Button
              variant="contained"
            >
              Add New
            </Button>
          </Link>
        </Box>
      </Box>

      <Paper
        elevation={4}
        sx={{
          marginTop: '20px'
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                Sr No.
              </TableCell>
              <TableCell>
                Title
              </TableCell>
              <TableCell>
                Status
              </TableCell>
              <TableCell>
                Created At
              </TableCell>
              <TableCell>
                Thumbnail
              </TableCell>
              <TableCell>
                Edit
              </TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {
              modalities.map((modality, ind) => {
                return (
                  <TableRow key={modality._id}>
                    <TableCell>
                      {ind + 1}
                    </TableCell>
                    <TableCell>
                      {modality.title}
                    </TableCell>
                    <TableCell>
                      <Switch
                        checked={modality.active}
                        onChange={(e) => handleChangeActiveStatus(e.target.checked, modality._id)}
                      />
                    </TableCell>
                    <TableCell>
                      {moment(modality.created_at).format('DD-MM-YYYY hh:mm A')}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        onClick={() => showThumbnailDialog(modality)}
                      >
                        <Image />
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <Link
                        to={`/edit-modality/${modality._id}`}
                      >
                        <IconButton>
                          <Edit />
                        </IconButton>
                      </Link>
                    </TableCell>
                  </TableRow>
                )
              })
            }
          </TableBody>
        </Table>

        <TablePagination
          component="div"
          count={count}
          page={page}
          rowsPerPage={10}
          rowsPerPageOptions={[]}
          onPageChange={handleChangePage}
        />
      </Paper>

      <ThumbnailDialog
        open={show_thumbnail_dialog}
        closeDialog={closeDialog}
        selected_id={selected_id}
        thumbnail_for={'modality'}
        thumbnail_file_name={thumbnail_file_name}
        getData={getData}
      />
    </Wrapper>
  )
}

export default Modalities;